/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};
(function(){
    var f;
    f = new Class({
        //Extends: GS.BaseClass,
        Extends: GS.Filters.BaseFilter,
        class_name:'GS.Filters.VarnishFilter',
        options:{
            'dx': 0,
            'hue':0,
            'staturation': 1,
            'lightness' : 0,
            'color_matrix':[],
            'brightness':0,
            'colorize':false,
            'shadow': {
                'display':0,
                'dx':3,
                'dy':3,
                'color': {'r':0,'g':0,'b':0,'a':1},
                'blur':1.5
            },
            'whitePointRGB' : {'r':255,'g':255,'b':255},
            'blackPointRGB' : {'r':0,'g':0,'b':0}
        },
        filter: {
            'id':0,
            'varnish' : false
        }
    });

    /*
     *
     * @returns {undefined}
     */
    f.prototype.createFilter=function(){
        var w = parseFloat(this.defs.ownerSVGElement.getAttribute('width')),
            h = parseFloat(this.defs.ownerSVGElement.getAttribute('height'));
        var f;
            //f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB', 'filterUnits': "objectBoundingBox"}),

        f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB','filterUnits': "userSpaceOnUse", 'x': -w,'y': -h,'width': 3*w,'height': 3*h/*,'enable-background':'accumulate'*/});
        this.filter.container=f;
        this.addColorFilter();
        this.defs.adopt(f);
    };

    f.prototype.addColorFilter=function(){

        // Add varnish....
        this.filter.varnish = this.addVarnish();
        this.filter.opacity = this.addMatrixFilter('opacity');
        //Add blend...
        this.filter.blend = this.addBlend();
        this.filter.container.adopt([this.filter.varnish, this.filter.opacity, this.filter.blend]);
        this.update(this.options);
    };

    f.prototype.update=function(obj){
        this.setVarnish(obj.personalization || null);

    }

    /**
     * Create Color Filter element
     * @returns {void}
     */
    f.prototype.addVarnish = function(){
        var f = new Element('feComponentTransfer',  {in: 'SourceAlpha', result: 'varnish'});
        f.innerHTML = '' +
            '  <feFuncR type="table" tableValues="0.8 0.8"></feFuncR>\n' +
            '  <feFuncG type="table" tableValues="0.8 0.8"></feFuncG>\n' +
            '  <feFuncB type="table" tableValues="0.8 0.8"></feFuncB>';
        return f;
    };
    f.prototype.addMatrixFilter = function(fx, type, values){
        if(!type) type = 'matrix';
        if(!values) values = '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0';
        return new Element('feColorMatrix',{'in':'varnish','data-fx': fx,'type': type,'result':'varnish','values': values});
    };
    f.prototype.addBlend = function(){
        return new Element('feBlend',  {in: 'SourceGraphic', in2: 'varnish', mode:"multiply"});
    };
    f.prototype.setVarnish = function(p){
        if(p && p.varnish){
            this.filter.opacity.setAttribute('values', "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        }else{
            this.filter.opacity.setAttribute('values', "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0 0");
        }
        //this.filter.blend.setAttribute('in', (p && p.varnish) ? 'SourceGraphic' : 'transformed');
    };
    f.prototype.setBlend = function(p){

    };

    this.VarnishFilter = f;
}.call(this.GS.Filters));
